/** Guest QR app theme ids stored on shared place settings. */
export const CUSTOMER_THEME_IDS = ['wortelogy', 'custom'] as const

export type CustomerThemeId = (typeof CUSTOMER_THEME_IDS)[number]

export const DEFAULT_CUSTOMER_THEME_ID: CustomerThemeId = 'wortelogy'

export interface CustomerThemePreview {
  bg: string
  surface: string
  text: string
  accent: string
}

export interface CustomerTheme {
  id: CustomerThemeId
  name: string
  description: string
  preview: CustomerThemePreview
}

const WORTELOGY_PREVIEW: CustomerThemePreview = {
  bg: '#f8fafc',
  surface: '#ffffff',
  text: '#0f172a',
  accent: '#0f172a',
}

const CUSTOM_PREVIEW: CustomerThemePreview = {
  bg: '#201C1C',
  surface: '#FDFEFD',
  text: '#FDFEFD',
  accent: '#201C1C',
}

export const CUSTOMER_THEMES: CustomerTheme[] = [
  {
    id: 'wortelogy',
    name: 'Wortelogy',
    description: 'Current guest app look',
    preview: WORTELOGY_PREVIEW,
  },
  {
    id: 'custom',
    name: 'Custom',
    description: 'Working theme — restyle this copy',
    preview: CUSTOM_PREVIEW,
  },
]

export function isCustomerThemeId(value: unknown): value is CustomerThemeId {
  return value === 'wortelogy' || value === 'custom'
}

export function resolveCustomerThemeId(value: unknown): CustomerThemeId {
  return isCustomerThemeId(value) ? value : DEFAULT_CUSTOMER_THEME_ID
}

export function customerThemeById(id: CustomerThemeId): CustomerTheme {
  return CUSTOMER_THEMES.find((theme) => theme.id === id) ?? CUSTOMER_THEMES[0]
}
